import type {DocumentReference, Firestore} from 'firebase/firestore';
import {doc, getFirestore} from 'firebase/firestore';

import {
  type SectionScheduleDocument,
  SectionScheduleDocumentSchema,
  getSectionScheduleDocumentPath,
} from '../documents/courseSectionSchedule';
import {createConverter} from './sdk';

const sectionScheduleConverter = createConverter({
  schema: SectionScheduleDocumentSchema,
  options: {validateOnRead: false, validateOnWrite: false},
});

export function getSectionScheduleDocumentRef({
  courseId,
  firestore = getFirestore(),
}: {
  courseId: string;
  firestore?: Firestore;
}): DocumentReference<SectionScheduleDocument> {
  return doc(
    firestore,
    getSectionScheduleDocumentPath({courseId}),
  ).withConverter(sectionScheduleConverter);
}
